var Component = require("/home/travis/build/tonyhhyip/library/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel!./../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Service.vue"),
  /* template */
  require("!!./../../../node_modules/vue-loader/lib/template-compiler?id=data-v-06ccffcc!./../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Service.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./assets/js/page/Service.vue
// module id = 65
// module chunks = 0